/**
 * Preisfilter Brutto/Netto-Konvertierung
 *
 * In Shopify werden Nettopreise gespeichert. B2C-Kunden sehen Bruttopreise im
 * Filter (Anzeige × Steuermultiplikator). Damit der Filter korrekt filtert,
 * müssen eingetippte Brutto-Werte vor dem Absenden auf Netto umgerechnet werden.
 *
 * price-facet-component bekommt data-tax-divisor="120" (AT) oder "119" (DE)
 * wenn der Kunde kein B2B-Kunde ist. Das JS liest diesen Wert und rechnet um.
 */

/**
 * Parst einen Preis-String (AT/DE-Format "1.200,50" oder "1200" oder "1200.50")
 * und gibt den numerischen Wert zurück.
 * @param {string} value
 * @returns {number}
 */
function parseDisplayPrice(value) {
  const s = String(value).trim();
  const commaIdx = s.lastIndexOf(',');
  const dotIdx = s.lastIndexOf('.');

  if (commaIdx > dotIdx) {
    return parseFloat(s.replace(/\./g, '').replace(',', '.'));
  }
  return parseFloat(s.replace(/,/g, ''));
}

/**
 * Formatiert einen Netto-Betrag zurück ins AT/EU-Format (Komma als Dezimaltrennzeichen).
 * @param {number} amount
 * @returns {string}
 */
function formatNettoPrice(amount) {
  return amount.toFixed(2).replace('.', ',');
}

/**
 * Hängt einen formdata-Listener an das Formular an, das den price-facet-component
 * enthält. Der Listener konvertiert Brutto-Eingaben zu Netto vor der Übertragung.
 * @param {Element} priceFacetEl
 */
function setupBruttoConversion(priceFacetEl) {
  const taxDivisor = parseInt(priceFacetEl.dataset.taxDivisor, 10);
  if (!taxDivisor || taxDivisor === 100) return;

  const form = priceFacetEl.closest('form');
  if (!form || form.dataset.bruttoConversionAttached) return;

  form.dataset.bruttoConversionAttached = 'true';

  form.addEventListener('formdata', (event) => {
    for (const param of ['filter.v.price.gte', 'filter.v.price.lte']) {
      const value = event.formData.get(param);
      if (!value || String(value).trim() === '') continue;

      const bruttoNum = parseDisplayPrice(String(value));
      if (isNaN(bruttoNum) || bruttoNum <= 0) continue;

      const nettoNum = (bruttoNum * 100) / taxDivisor;
      event.formData.set(param, formatNettoPrice(nettoNum));
    }
  });
}

document.querySelectorAll('price-facet-component[data-tax-divisor]').forEach(setupBruttoConversion);

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;
      node
        .querySelectorAll('price-facet-component[data-tax-divisor]')
        .forEach(setupBruttoConversion);
      if (node.matches('price-facet-component[data-tax-divisor]')) {
        setupBruttoConversion(node);
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });
